import actionTypes from "./_actions";

const _saveGHGSection = (offlineFarms, payload) => {
    let { section } = payload;
    const { farmId, budgetId, sectionName } = payload;

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            ghg: {
                                ...offlineBudget.budget.ghg,
                                [sectionName]: section,
                            },
                        },
                    };
                }),
            },
        };
    });
};

const _deleteGHGSection = (offlineFarms, payload) => {
    const { farmId, budgetId, sectionName } = payload;

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            ghg: {
                                ...offlineBudget.budget.ghg,
                                [sectionName]: null,
                            },
                        },
                    };
                }),
            },
        };
    });
};

const reducer = (state = [], action) => {
    let offlineFarms = state;
    if (!Array.isArray(state)) {
        offlineFarms = Object.keys(state).map((item) => state[item]);
    }

    switch (action.type) {
        case actionTypes.GHG_SAVE_SECTION:
            return _saveGHGSection(offlineFarms, action.payload);

        case actionTypes.GHG_DELETE_SECTION:
            return _deleteGHGSection(offlineFarms, action.payload);

        default:
            return offlineFarms;
    }
};

export default reducer;
